var _defs, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Group_13017",
    "data-name": "Group 13017",
    width: 20,
    height: 20,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.04,
    y1: 2.516,
    x2: 0.259,
    y2: -0.717,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#405cfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ab5fc"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3781",
    "data-name": "Rectangle 3781",
    width: 20,
    height: 2,
    rx: 1,
    fill: "url(#linear-gradient)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3782",
    "data-name": "Rectangle 3782",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(0 5)",
    fill: "url(#linear-gradient)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3783",
    "data-name": "Rectangle 3783",
    width: 20,
    height: 2,
    rx: 1,
    transform: "translate(0 10)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.2c00d75f35528f1b9d1d9103c86a6717.svg";
export { ForwardRef as ReactComponent };